<div class="select-box" [class.select-box--disabled]="disabled"  [class.select-box--min-height]="minHeight">
  @if (!colorSelect && imageUrl) {
    <img
      class="select-box--img"
      [src]="imageUrl"
      [alt]="title"
      defaultImg
      />
  }
  @if (colorSelect) {
    <div
      class="select-box--color"
      >
      <span
        [style.backgroundColor]="color"
        [style.backgroundImage]="'url(' + imageUrl + ')'"
      ></span>
    </div>
  }
  <p class="select-box--title">{{ title }}
    @if (infoContent) {
      <button
        class="item-imgTitleDescription-info-button mat-elevation-z0"
        mat-icon-button
        color="secondary"
        (click)="showInfoContent.emit()"
        >
        <mat-icon class="mat-18">info</mat-icon>
      </button>
    }
  </p>
  @if (!descriptionTemplate) {
    <p class="select-box--description" [innerHtml]="description"></p>
  }
  @if (descriptionTemplate) {
    <div class="select-box--description">
      <ng-container
        [ngTemplateOutlet]="descriptionTemplate"
        [ngTemplateOutletContext]="descriptionContext"
      ></ng-container>
    </div>
  }
  <div class="select-box--button" [ngStyle]="buttonCustomStyle ? {'width' : 100 + '%' } : ''">
    @if (buttonText) {
      <button
        [disabled]="disabled || disabledButton1"
        mat-raised-button
        color="primary"
        (click)="select.emit()"
        >
        {{ buttonText | uppercase }}
      </button>
    }
    @if (buttonText2) {
      <button
        [disabled]="disabled || disabledButton2"
        mat-raised-button
        color="primary"
        (click)="select2.emit()"
        >
        {{ buttonText2 | uppercase }}
      </button>
    }
    @if (buttonText3) {
      <button
        [disabled]="disabled || disabledButton3"
        mat-raised-button
        color="primary"
        (click)="select3.emit()"
        >
        {{ buttonText3 | uppercase }}
      </button>
    }
    @if (buttonText4) {
      <button
        [disabled]="disabled || disabledButton4"
        mat-raised-button
        color="primary"
        (click)="select4.emit()"
        >
        {{ buttonText4 | uppercase }}
      </button>
    }
    @if (buttonExpandMore) {
      <div>
        <button
          class="select-box--button-dropdown-arrow"
          color="primary"
          mat-raised-button
          [matMenuTriggerFor]="menu"
          >
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="after">
          <button mat-raised-button (click)="selectExpandMore.emit()" class="select-box--mat-menu-option">
            {{ buttonExpandMore | uppercase }}
          </button>
        </mat-menu>
      </div>
    }
  </div>
</div>
